import React, { ReactNode } from "react";
import cn from "classnames";
import styles from "./fluid-to-fix-split-container.module.scss";

interface FluidToFixSplitContainerPropTypes {
  lessPadding?: boolean;
  noPadding?: boolean;
  children: ReactNode;
}

const cssClassName = "fluid-to-fix-split-container";

export const FluidToFixSplitContainer = ({
  lessPadding,
  noPadding,
  children,
}: FluidToFixSplitContainerPropTypes) => {
  const childArray = React.Children.toArray(children);
  const midpoint = Math.ceil(childArray.length / 2);

  const firstHalfChildren = childArray.slice(0, midpoint);
  const secondHalfChildren = childArray.slice(midpoint);

  return (
    <div className={styles[cssClassName]}>
      <div
        className={cn(styles[`${cssClassName}__first-group`], {
          [styles[`${cssClassName}__first-group--less-padding`]]: lessPadding,
          [styles[`${cssClassName}__first-group--no-padding`]]: noPadding,
        })}
      >
        {firstHalfChildren}
      </div>
      {secondHalfChildren.length > 0 && (
        <div
          className={cn(styles[`${cssClassName}__second-group`], {
            [styles[`${cssClassName}__second-group--less-padding`]]:
              lessPadding,
          })}
        >
          {secondHalfChildren}
        </div>
      )}
    </div>
  );
};
